import { useAppDispatch, useAppSelector } from 'hooks'
import { useEffect } from 'react'
import { getIsRejectedSelector } from 'redux/store/slices/userSlice'
import notificationsWs from 'utils/sockets/notifications-ws'

import { useLazyGetUserQuery } from './redux/api/leadsApi'
import { isLoggedInSelector } from './redux/store/slices/authSlice'
import Router from './router'

function App() {
  // Tools
  const dispatch = useAppDispatch()

  // Selectors
  const isAuth = useAppSelector(isLoggedInSelector)
  const isRejected = useAppSelector(getIsRejectedSelector)

  // Queries and Mutations
  const [fetchUser] = useLazyGetUserQuery()

  useEffect(() => {
    const fetchUserData = async () => {
      if (isAuth && !isRejected) {
        const {
          record: { iin }
        } = await fetchUser().unwrap()
        await dispatch(notificationsWs({ iin }))
      }
    }

    fetchUserData()
  }, [dispatch, fetchUser, isAuth, isRejected])

  return <Router />
}

export default App
